import React from "react";
import "./ProductivitySection.css";

const features = [
  {
    icon: "/assets/productivity-booking.svg",
    title: "Faster bookings",
  },
  {
    icon: "/assets/productivity-service.svg",
    title: "Stronger customer service",
  },
  {
    icon: "/assets/productivity-gain.svg",
    title: "Real productivity gains",
  },
];

function ProductivitySection() {
  return (
    <section className="section-padding">
      <div className="productivity-box">

        <h2 className="heading-title productivity-heading">
          <span className="title-blue">Guaranteed</span> Productivity & Efficiency
        </h2>

        <p className="desc productivity-desc">
          Sabre's technology and TNS's local expertise combine to deliver
          measurable results for your agency — faster bookings, stronger
          customer service, and real gains in day-to-day productivity.
        </p>

        <div className="productivity-features">
          {features.map((item, index) => (
            <div className="productivity-card" key={index}>
              <img src={item.icon} alt={item.title} />
              <span>{item.title}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default ProductivitySection;